import { z } from 'zod';
import { SeatLimitSchema } from '../../entities/tenant/tenant.schema';
/**
 * One seat pool: its cap and the seats currently taken. A seat is a LOGIN, not
 * a person: `used` counts the not-deleted users that were invited or have
 * activated (status 'pending' or 'active'), so a never-invited or suspended
 * user is not in it. `limit: null` means unlimited — distinct from `limit: 0`,
 * which means no seats at all.
 */ export const SeatPoolUsageSchema = z.object({
    limit: SeatLimitSchema.nullable(),
    used: z.number().int().nonnegative()
});
/**
 * Seat Usage Response Schema
 * GET /api/v2/tenants/:tenantId/seat-usage
 * GET /api/v2/organization/seat-usage
 */ export const SeatUsageResponseSchema = z.object({
    data: z.object({
        systemAdmins: SeatPoolUsageSchema,
        orgManagers: SeatPoolUsageSchema,
        members: SeatPoolUsageSchema
    })
});

//# sourceMappingURL=seat-usage.schema.js.map